import React from "react";

import styled from "styled-components";
import {
    StandardModalFormGrid,
    StandardModalInput,
    StandardModalLabel,
    portalColors
} from "src/components";

export const ScrollingContainer = styled.div`
    max-height: 345px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 25px;
    display: grid;
    gap: 0.75rem;

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        border-radius: 6px;
        border-right: none;
        border-left: none;
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${portalColors.text};
        border-radius: 6px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-track-piece:start {
        background-color: ${portalColors.surfaceTertiary};
        border-radius: 6px;
        margin-top: 0 !important;
    }

    ::-webkit-scrollbar-track-piece:end {
        background-color: ${portalColors.surfaceTertiary};
        border-radius: 6px;
    }
`;

export const StyledLabel = styled(StandardModalLabel)`
    margin-bottom: 0.25rem;
`;

export const StyledInput = styled(StandardModalInput)`
    height: 2.5rem;
    width: 100%;
`;

const MultipleInvitesForm = (props) => {
    const { users } = props;
    const renderRows = () => {
        return users.map((user, index) => {
            const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim();

            return (
                <StandardModalFormGrid columns="repeat(3, minmax(0, 1fr))" key={index}>
                    <StyledInput value={fullName} readOnly />
                    <StyledInput value={user.email} readOnly />
                    <StyledInput value={user.phoneNumber} readOnly />
                </StandardModalFormGrid>
            );
        });
    };

    return (
        <>
            <StandardModalFormGrid columns="repeat(3, minmax(0, 1fr))">
                <StyledLabel>Name</StyledLabel>
                <StyledLabel>Email</StyledLabel>
                <StyledLabel>Mobile</StyledLabel>
            </StandardModalFormGrid>
            <ScrollingContainer>
                { renderRows() }
            </ScrollingContainer>
        </>
    );
};

export default MultipleInvitesForm;
